<app-main-dialog [onlyMobile]="true"
  (dismiss)="dismiss(true)">
  <div modalTitle></div>
  <div class="flex tw:flex flex-center tw:justify-center header">
    <div class="logo">
      <img src="./assets/images/logo.png" />
    </div>
    <h4>{{ 'nav.app' | translate }}</h4>
    @if (version(); as version) {
      <ion-note>Version {{ version }}</ion-note>
    }
  </div>
  <div class="container">
    <div class="inner-container">
      <div class="nav-container">
        <div class="desktop title">
          <h4>{{ 'nav.selectAction' | translate }}</h4>
          <ion-button color="light"
            shape="round"
            (click)="dismiss(true)">
            {{ 'general.close' | translate }}
          </ion-button>
        </div>
        <div class="search-container">
          <app-search [inner]="true"
            (hasText)="onSearching($event)"
            (searched)="dismiss()"></app-search>
        </div>
        @if (!searching()) {
          <div class="nav">
            @if (selectedItem() == null) {
              @switch (role()) {
                @case ('admin') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.admin.items }">
                  </ng-container>
                } @case ('supervisor') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.supervisor.items }">
                  </ng-container>
                } @case ('worker') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.worker.items }">
                  </ng-container>
                } @case ('managerWorker') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: managerWorkerMenuItems() }">
                  </ng-container>
                } @case ('super-admin') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.superAdmin.items }">
                  </ng-container>
                } @case ('manager') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.manager.items }">
                  </ng-container>
                } @case ('storage') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.storage.items }">
                  </ng-container>
                } @case ('partner') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.partner.items }">
                  </ng-container>
                } @case ('premium-partner') {
                  <ng-container [ngTemplateOutlet]="itemsTemplate"
                    [ngTemplateOutletContext]="{ items: appMenu.partner.items }">
                  </ng-container>
                }
              }
            } @else {
              <ng-container [ngTemplateOutlet]="itemsTemplate"
                [ngTemplateOutletContext]="{ items: selectedItem().children }">
              </ng-container>
            }
          </div>
        }
      </div>
      @if (!['admin', 'supervisor', 'worker'].includes(role())) {
        <div class="flex tw:flex list">
          <ion-item button
            lines="none"
            detail="false"
            (click)="navigate(['/options'])">
            <ion-icon slot="start"
              name="information-circle"></ion-icon>
            {{ 'nav.extras' | translate }}
          </ion-item>
        </div>
      }
    </div>
  </div>
</app-main-dialog>
<ng-template #itemsTemplate
  let-items="items">
  @for (item of items; track item.name) {
    <div class="nav-item tw:cursor-pointer"
      (click)="onItem(item)">
      <ion-icon [name]="item.icon"></ion-icon>
      <div>
        {{ item.name | translate }}
      </div>
    </div>
  }
  <div class="nav-item tw:cursor-pointer"
    (click)="navigate(['/instructions'])">
    <ion-icon name="book"></ion-icon>
    <div>{{ 'help.title' | translate }}</div>
  </div>
</ng-template>
